import React from "react";
import WithdrawalApplyFinish from "../pages/WithdrawalApplyFinish";

const WithdrawalApplyFinishContainer = () => {
    return <WithdrawalApplyFinish />;
};

export default WithdrawalApplyFinishContainer;
